export class ThemeColor {
    name: string;
    displayText: string;
    class: string;
    compactStyleName: string;
    materialStyleName: string;
    customStylesheetName?: string;
}

export const themeColors: ThemeColor[] = [
    {
        name: 'light-blue',
        displayText: 'Blue Light Background',
        class: 'cc-devex-theme-color cc-devex-light-blue',
        compactStyleName: 'generic.light.compact',
        materialStyleName: 'material.blue.light',
        customStylesheetName: 'cc-light-blue'
    },
    {
        name: 'dark-blue',
        displayText: 'Blue Dark Background',
        class: 'cc-devex-theme-color cc-devex-dark-blue',
        compactStyleName: 'generic.dark.compact',
        materialStyleName: 'material.blue.dark',
        customStylesheetName: 'cc-dark-blue'
    },
    {
        name: 'light-orange',
        displayText: 'Orange Light Background',
        class: 'cc-devex-theme-color cc-devex-light-orange',
        compactStyleName: 'generic.carmine.compact',
        materialStyleName: 'material.orange.light',
        customStylesheetName: 'cc-light-orange'
    },
    {
        name: 'light-teal',
        displayText: 'Teal Light Background',
        class: 'cc-devex-theme-color cc-devex-light-teal',
        compactStyleName: 'generic.greenmist.compact',
        materialStyleName: 'material.teal.light',
        customStylesheetName: 'cc-light-teal'
    }
];

export const defaultPaletteName = 'Material';

export const defaultPaletteMode = 'Blend';

export const chartPaletteNames: string[] = [
    'Material',
    'Soft Pastel',
    'Harmony Light',
    'Pastel',
    'Bright',
    'Soft',
    'Ocean',
    'Office',
    'Vintage',
    'Violet',
    'Carmine',
    'Dark Moon',
    'Soft Blue',
    'Dark Violet',
    'Green Mist'
];

export const chartPaletteExtensionModes: string[] = ['Alternate', 'Blend', 'Extrapolate'];

export const calendarColors: string[] = [
    '#2a7ee4',
    '#727bd2',
    '#7b49d3',
    '#00af2c',
    '#32c9ed',
    '#56ca85',
    '#8ecd3c',
    '#cc5c53',
    '#ff9747',
    '#581845',
    '#900C3F',
    '#C70039',
    '#7533FF',
    '#3366FF'
];
